import { render, staticRenderFns } from "./syzn.vue?vue&type=template&id=5b68a6f6&scoped=true&"
var script = {}
import style0 from "./syzn.vue?vue&type=style&index=0&id=5b68a6f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b68a6f6",
  null
  
)

export default component.exports